import PropTypes from "prop-types";
import { styled, alpha } from "@mui/material/styles";
import {
  Toolbar,
  OutlinedInput,
  InputAdornment,
  Autocomplete,
  Grid,
  TextField,
  Button,
  Paper,
} from "@mui/material";
import Iconify from "../../../../components/iconify";
import AutoCompleteDropDown from "../../../../components/auto-complete-dropdown";
import { usePersistentState } from "../../../../contexts/global-context";
import { useEffect, useState } from "react";
import { GetLocalStorage } from "../../../../utils/local-storage";
import FullScreenLoader from "../../../../components/full-screen-loader";
import { GET } from "../../../../config/https";
import APIS from "../../../../config/api";
import { useNavigate } from "react-router-dom";
import Color from "../../../../theme/color";

// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 135,
  padding: theme.spacing(0, 1, 0, 1),
  [theme.breakpoints.down("sm")]: {
    height: 165,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));
const StyledSearch = styled(OutlinedInput)(({ theme }: any) => ({
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": {
    boxShadow: theme.customShadows.z8,
  },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

TableToolbar.propTypes = {
  numSelected: PropTypes.any,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  onOrganizerChange: PropTypes.func,
  category: PropTypes.any,
  options: PropTypes.any,
  onChange: PropTypes.any,
  placeholder: PropTypes.any,
  loggedInUser: PropTypes.any,
  value: PropTypes.any,
};

export default function TableToolbar({
  numSelected,
  filterName,
  onFilterName,
  category,
  onChange,
  placeholder,
  options,
  valueOrganizer,
  onOrganizerChange,
  loggedInUser,
  value,
}: any) {
  const [state]: any = usePersistentState();
  const [loader, setLoader] = useState(false);
  const [loginInfo, setLoginInfo] = useState<any>({});
  const [checked, setChecked] = useState(true);
  const [userData, setUserData] = useState<any>({});
  const navigate = useNavigate();
  useEffect(() => {
    GetUserData();
  }, []);

  useEffect(() => {
    let tempData = GetLocalStorage("loginData");
    setLoginInfo(tempData);
  }, [state.users]);

  const GetUserData = async () => {
    let userData = GetLocalStorage("loginData");
    let params: any = {
      id: userData.id,
    };
    setLoader(true);
    await GET(APIS.GET_USER_BY_ID, params)
      .then((res: any) => {
        if (res?.isSuccess) {
          setUserData(res?.result);
        } else {
          console.log("GetUserData error");
        }
      })
      .catch((error) => {
        setLoader(false);

        console.log("error", error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const userRole = loginInfo.roles;

  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: "primary.main",
          bgcolor: "primary.lighter",
        }),
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={3}>
          <StyledSearch
            fullWidth
            size="small"
            value={filterName}
            onChange={onFilterName}
            placeholder={placeholder}
            startAdornment={
              <InputAdornment position="start">
                <Iconify
                  icon="eva:search-fill"
                  sx={{ color: "text.disabled", width: 20, height: 20 }}
                />
              </InputAdornment>
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <AutoCompleteDropDown
            data={category}
            onChange={onChange}
            label={"title"}
            placeholder={"Event Name"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          {userRole?.name === "Host" ? (
            <Autocomplete
              size="small"
              disablePortal
              style={{ backgroundColor: "#fff", width: "100%" }}
              options={options}
              value={userData?.companyName}
              onChange={onOrganizerChange}
              renderInput={(params) => (
                <TextField {...params} placeholder="Organizer" />
              )}
              PaperComponent={(props) => (
                <Paper
                  {...props}
                  style={{
                    ...props.style,
                    border: " 1px solid #acacac",
                  }}
                />
              )}
              disabled={checked}
            />
          ) : (
            <Autocomplete
              size="small"
              disablePortal
              style={{ backgroundColor: "#fff", width: "100%" }}
              options={options}
              value={value}
              onChange={onOrganizerChange}
              renderInput={(params) => (
                <TextField {...params} placeholder="Organizer" />
              )}
              PaperComponent={(props) => (
                <Paper
                  {...props}
                  style={{
                    ...props.style,
                    border: " 1px solid #acacac",
                  }}
                />
              )}
            />
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          style={{ display: "flex", justifyContent: "end" }}
        >
          {" "}
          <Button
            variant="contained"
            style={{ backgroundColor: Color.primary }}
            startIcon={<Iconify icon="eva:plus-fill" />}
            onClick={() => {
              navigate("/dashboard/coupon/add", {
                state: {
                  isEditable: false,
                },
              });
            }}
          >
            Add Coupon
          </Button>
        </Grid>
      </Grid>
      <FullScreenLoader open={loader} />
    </StyledRoot>
  );
}
